<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="showLoading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{message ? message: "Please stand by"}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PaymentModal',
  props: {
    message: String,
    specific: Boolean,
  },
  computed: {
    ...mapState(['admin', 'enrollments', 'loading']),
    showLoading () {
      if (this.specific) {
        return this.dialog
      } else {
        return this.loading
      }
    },
    newBalance() {
      if (this.newPaymentEnrollmentData.remaining_balance) {
        return (this.newPaymentEnrollmentData.remaining_balance - (this.newPayment.amount || 0)).toFixed(2)
      } else {
        return
      }
    },
  },
  data() {
    return {
      dialog: false,
    }
  },

}
</script>
